import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';

type GetUnapprovedInvoicesPayload = Parameters<
  ReturnType<typeof getPrivateApi>['getUnapprovedInvoicesReport']
>[0];

export function useGetUnapprovedInvoicesReport(
  options?: UseMutationOptions<Blob, unknown, GetUnapprovedInvoicesPayload>,
) {
  return useMutation(
    ['revenue-report'],
    async (payload) => {
      const privateApi = getPrivateApi();
      const reportId = payload?.reportId;

      const unapprovedInvoicesReport = await privateApi.getUnapprovedInvoicesReport({
        reportId,
      });

      return unapprovedInvoicesReport;
    },
    options,
  );
}
